import React from 'react';
import { MdOutlineShoppingCart } from "react-icons/md";
import './Header.css';

function Header({ cartCount, onCartClick, catalogName = 'Каталог товаров' }) {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">{catalogName}</h1>
        <button className="cart-button" onClick={onCartClick}>
          <MdOutlineShoppingCart className="cart-icon" />
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </button>
      </div>
    </header>
  );
}

export default Header;

